import { env, region } from '@fhs-legacy/frontend/src/utils/environment';

/**
 * Optional overrides (Expo / Metro inlines `EXPO_PUBLIC_*` at build time).
 *
 * Note: `sanity dev` at http://localhost:3333 is only the Studio UI. The app still
 * reads content from Sanity’s hosted API (`*.api.sanity.io`). Match **project + dataset**
 * to the values in `fhs-app-cms/sanity.config.json` (from `yarn config:dev`) so edits in
 * local Studio show up in the app—there is no separate “CMS API” on port 3333.
 */
function envOverride(key: 'EXPO_PUBLIC_SANITY_PROJECT_ID' | 'EXPO_PUBLIC_SANITY_DATASET'): string | undefined {
  const v = process.env[key]?.trim();
  return v || undefined;
}

const defaultSanityProjectId = 'czqk28jt';
export const sanityProjectId = envOverride('EXPO_PUBLIC_SANITY_PROJECT_ID') ?? defaultSanityProjectId;

// env() and region() rely on Expo runtime (expo-constants), which is unavailable in non-Expo contexts (e.g. backend/build).
// We wrap in try-catch to fall back to process.env when Expo isn't available.
function getSafeEnv(): string {
  try {
    return String(env()).toLowerCase() ?? 'dev';
  } catch {
    return process.env.REACT_APP_RBI_ENV ?? 'dev';
  }
}

function getSafeRegion(): string {
  try {
    return String(region()).toLowerCase() ?? 'us';
  } catch {
    return process.env.REACT_APP_RBI_COUNTRY ?? 'us';
  }
}

export const sanityStage = getSafeEnv();
export const sanityRegion = getSafeRegion();
export const useCdn = sanityStage === 'qa' || sanityStage === 'dev' ? false : true;
export const sanityDataset =
  envOverride('EXPO_PUBLIC_SANITY_DATASET') ?? `${sanityStage}_fhs_${sanityRegion}`;
